import PropTypes from 'prop-types';
import React from 'react';

import IfmsButton, { IfmsButtonProps } from './IfmsButton';

const HighlightButton = React.forwardRef<HTMLButtonElement, IfmsButtonProps>(({children, ...other}, ref) => {
  return (
    <IfmsButton ref={ref} {...other} baseClass="ifms-highlight-button">
      {children}
    </IfmsButton>
  );
});

HighlightButton.defaultProps = {
};

HighlightButton.propTypes = {
  size: PropTypes.oneOf(['regular', 'small', 'large', 'extrasmall']),
};

export default React.memo(HighlightButton);

